import apiClient from './client'

export interface PromoCodeValidateResponse {
  valid: boolean
  code: string
  discount_percent?: number
  discount_duration_days?: number
  description?: string
  reason?: string
}

export interface PromoCodeRedeemResponse {
  code: string
  discount_percent: number
  discount_expires_at: string
}

export interface ActiveDiscountResponse {
  has_active_discount: boolean
  discount_percent?: number
  discount_expires_at?: string
  promo_code?: string
}

export const promoCodesApi = {
  /**
   * Проверить промокод (без применения).
   */
  validate: async (code: string): Promise<PromoCodeValidateResponse> => {
    const response = await apiClient.post<PromoCodeValidateResponse>('/promo-codes/validate', { code })
    return response.data
  },

  /**
   * Применить промокод. Скидка начнёт действовать сразу.
   */
  redeem: async (code: string): Promise<PromoCodeRedeemResponse> => {
    const response = await apiClient.post<PromoCodeRedeemResponse>('/promo-codes/redeem', { code })
    return response.data
  },

  /**
   * Получить текущую активную скидку пользователя (если есть).
   */
  getActiveDiscount: async (): Promise<ActiveDiscountResponse> => {
    const response = await apiClient.get<ActiveDiscountResponse>('/promo-codes/active-discount')
    return response.data
  },
}
